import BaseApi from '../../../infraestructure/BaseApi';

export default class ApiCourseCategories extends BaseApi {
    constructor(client, endPoint) {
        super(client, endPoint)
    }
}